import React, { Component } from 'react'
import imgResize from '@/utils/img-resize'
import styles from './index.module.less'
import { LangEum } from '@/constant'

const zhTW = {
  topBarTtemContent: {
    fontSize: 9,
  },
}

const stylesMap: any = {
  [LangEum['zh-TW']]: zhTW,
  [LangEum['zh-MO']]: zhTW,
  [LangEum['zh-TW2']]: zhTW,
  [LangEum['zh-SG']]: zhTW,
  [LangEum['zh-MY']]: zhTW,
  zh: zhTW,
  en: {
    topBarTtemContent: {
      fontSize: '0.09rem',
    },
    icon: {
      marginRight: '0.08rem',
    },
  },
}

interface Iprops {
  propsConfig: {
    config: { iconSrc: string; content: string }[]
    bgColor: string
    backgroundImg: string
  }
  editConfig: any
}

class Topbar extends Component<Iprops, any> {
  static config = {
    name: 'poizon-top-bar',
  }

  render() {
    const { propsConfig } = this.props
    const { config = [], bgColor, backgroundImg } = propsConfig || {}
    const { lang, local } = this.props?.editConfig
    const styleCfg = stylesMap[lang || 'zh-TW'] || zhTW
    if (lang === 'en') {

      return <img className={styles['poizon-top-bar-img']} src={imgResize(backgroundImg, 750)} alt="" />
    }
    return (
      <div style={{ background: bgColor || '#000' }} className={styles['poizon-top-bar-wrapper']}>
        {lang !== 'en' &&
          config.map((ele) => (
            <div key={ele.content} className={styles['top-bar-item-wrapper']}>
              <img
                style={styleCfg.icon || {}}
                className={styles['top-bar-item-img']}
                src={imgResize(ele.iconSrc, 28)}
                alt=""
              />
              <span
                style={styleCfg.topBarTtemContent || {}}
                className={styles['top-bar-item-content']}
              >
                {ele.content}
              </span>
            </div>
          ))}
      </div>
    )
  }
}

Topbar.config = {
  name: 'poizon-top-bar',
}

export default Topbar
